import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const NAME_SX = {
  display: 'block',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

const InterruptionCreatorName = ({ children }: PropsWithChildren) => (
  <Box component="span" sx={NAME_SX}>
    {children}
  </Box>
);

export default InterruptionCreatorName;
